import moment from "moment";
import { axios } from "../connection/ConnectionHandler";
import { UPDATE_PERMISSION } from '../constants';
import { API } from "../constants/api";
import { createCrudActions } from '../utils/crudGenerator';

const formatPermissions = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
        endDate: item.endDate && moment(item.endDate),
        startDate: item.startDate && moment(item.startDate),
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchPermissions,
    create: createPermission,
    update: updatePermission,
    delete: deletePermissions
} = createCrudActions('PERMISSION', "Permiso", formatPermissions);

export const approvePermission = (permissionId, approvedBy) => {
    return async (dispatch) => {
        try {
            const response = await axios.put(`${API.permissions.base}/${permissionId}/approve`, {
                approvedBy
            });

            // Actualizar el permiso en el store
            dispatch({
                type: UPDATE_PERMISSION,
                payload: formatPermissions(response.data)
            });

            return { success: true, status: response.status };
        } catch (error) {
            const errorMessage = error.response?.data?.error || "Error al aprobar el permiso.";

            // Crear un error personalizado con el mensaje para que llegue al componente
            const customError = new Error(errorMessage);
            customError.payload = { error: errorMessage };
            throw customError;
        }
    };
};

export const denyPermission = (permissionId, deniedReason, approvedBy) => {
    return async (dispatch) => {
        try {
            const response = await axios.put(`${API.permissions.base}/${permissionId}/deny`, {
                deniedReason,
                approvedBy
            });

            // Actualizar el permiso en el store
            dispatch({
                type: UPDATE_PERMISSION,
                payload: formatPermissions(response.data)
            });

            return { success: true, status: response.status };
        } catch (error) {
            const errorMessage = error.response?.data?.error || "Error al denegar el permiso.";

            // Crear un error personalizado con el mensaje para que llegue al componente
            const customError = new Error(errorMessage);
            customError.payload = { error: errorMessage };
            throw customError;
        }
    };
};

export const getUserPermissionStats = (userId, year = null) => {
    return async (dispatch) => {
        const currentYear = year || new Date().getFullYear();

        try {
            const response = await axios.get(`${API.permissions.base}/stats/${userId}?year=${currentYear}`);

            return response.data;
        } catch (error) {
            console.error("Error al obtener estadísticas de permisos:", error);

            // Retornar estructura vacía en caso de error
            return {
                year: currentYear,
                vacations: {
                    approved: 0,
                    pending: 0,
                    total: 0,
                    remaining: 0
                },
                personalAffairs: {
                    approved: 0,
                    pending: 0,
                    total: 0,
                    remaining: 0
                }
            };
        }
    };
};
